export default {
  İSTANBUL: {
    nearBy: [
      { value: '59', label: 'TEKİRDAĞ' },
      { value: '16', label: 'BURSA' },
      { value: '41', label: 'KOCAELİ' },
      { value: '22', label: 'EDİRNE' },
      { value: '34', label: 'İSTANBUL' }
    ]
  },
  ANKARA: {
    nearBy: [
      { value: '71', label: 'KIRIKKALE' },
      { value: '14', label: 'BOLU' },
      { value: '6', label: 'ANKARA' },
      { value: '26', label: 'ESKİŞEHİR' }
    ]
  },
  ELAZIĞ: {
    nearBy: [
      { value: '2', label: 'ADIYAMAN' },
      { value: '12', label: 'BİNGÖL' },
      { value: '21', label: 'DİYARBAKIR' },
      { value: '44', label: 'MALATYA' },
      { value: '62', label: 'TUNCELİ' },
      { value: '23', label: 'ELAZIĞ' }
    ]
  },
  BURSA: {
    nearBy: [
      { value: '10', label: 'BALIKESİR' },
      { value: '11', label: 'BİLECİK' },
      { value: '34', label: 'İSTANBUL' },
      { value: '41', label: 'KOCAELİ' },
      { value: '16', label: 'BURSA' }
    ]
  },
  ESKİŞEHİR: {
    nearBy: [
      { value: '6', label: 'ANKARA' },
      { value: '16', label: 'BURSA' },
      { value: '26', label: 'ESKİŞEHİR' }
    ]
  },
  İZMİR: {
    nearBy: [
      { value: '9', label: 'AYDIN' },
      { value: '20', label: 'DENİZLİ' },
      { value: '45', label: 'MANİSA' },
      { value: '35', label: 'İZMİR' }
    ]
  },
  MANİSA: {
    nearBy: [
      { value: '9', label: 'AYDIN' },
      { value: '20', label: 'DENİZLİ' },
      { value: '45', label: 'MANİSA' },
      { value: '35', label: 'İZMİR' }
    ]
  },
  ADANA: {
    nearBy: [
      { value: "80", label: "OSMANİYE" },
      { value: "33", label: "MERSİN" },
      { value: "01", label: "ADANA" }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/constants/near-by-citites.js